// Dropdown API - GetVolumeTrendReportsDDList
export const FETCH_VOLUME_TREND_REPORTS_DD_REQUEST =
  "FETCH_VOLUME_TREND_REPORTS_DD_REQUEST";
export const FETCH_VOLUME_TREND_REPORTS_DD_SUCCESS =
  "FETCH_VOLUME_TREND_REPORTS_DD_SUCCESS";
export const FETCH_VOLUME_TREND_REPORTS_DD_FAILURE =
  "FETCH_VOLUME_TREND_REPORTS_DD_FAILURE";

// Reports Tab - GetDemandTableReportsWithPagination
export const FETCH_REPORTS_TAB_REQUEST = "FETCH_REPORTS_TAB_REQUEST";
export const FETCH_REPORTS_TAB_SUCCESS = "FETCH_REPORTS_TAB_SUCCESS";
export const FETCH_REPORTS_TAB_FAILURE = "FETCH_REPORTS_TAB_FAILURE";

// Onboarding Tab - GetDemandInputOnboardingData
export const FETCH_ONBOARDING_TAB_REQUEST = "FETCH_ONBOARDING_TAB_REQUEST";
export const FETCH_ONBOARDING_TAB_SUCCESS = "FETCH_ONBOARDING_TAB_SUCCESS";
export const FETCH_ONBOARDING_TAB_FAILURE = "FETCH_ONBOARDING_TAB_FAILURE";

// Notes Edit Actions
export const FETCH_NOTES_EDIT_REQUEST = "FETCH_NOTES_EDIT_REQUEST";
export const FETCH_NOTES_EDIT_SUCCESS = "FETCH_NOTES_EDIT_SUCCESS";
export const FETCH_NOTES_EDIT_FAILURE = "FETCH_NOTES_EDIT_FAILURE";

// Notes Save Actions
export const FETCH_NOTES_SAVE_REQUEST = "FETCH_NOTES_SAVE_REQUEST";
export const FETCH_NOTES_SAVE_SUCCESS = "FETCH_NOTES_SAVE_SUCCESS";
export const FETCH_NOTES_SAVE_FAILURE = "FETCH_NOTES_SAVE_FAILURE";

//Export Reports Tab Actions
export const EXPORT_REPORTS_REQUEST = "EXPORT_REPORTS_REQUEST";
export const EXPORT_REPORTS_SUCCESS = "EXPORT_REPORTS_SUCCESS";
export const EXPORT_REPORTS_FAILURE = "EXPORT_REPORTS_FAILURE";

// Get DemandTableID by Report
export const FETCH_DEMAND_TABLE_BY_REPORT_REQUEST =
  "FETCH_DEMAND_TABLE_BY_REPORT_REQUEST";
export const FETCH_DEMAND_TABLE_BY_REPORT_SUCCESS =
  "FETCH_DEMAND_TABLE_BY_REPORT_SUCCESS";
export const FETCH_DEMAND_TABLE_BY_REPORT_FAILURE =
  "FETCH_DEMAND_TABLE_BY_REPORT_FAILURE";

// Fetch Get Demand Input Filter Dropdown List
export const FETCH_GET_DEMAND_INPUT_FILTER_DD_LIST_REQUEST =
  "FETCH_GET_DEMAND_INPUT_FILTER_DD_LIST_REQUEST";
export const FETCH_GET_DEMAND_INPUT_FILTER_DD_LIST_SUCCESS =
  "FETCH_GET_DEMAND_INPUT_FILTER_DD_LIST_SUCCESS";
export const FETCH_GET_DEMAND_INPUT_FILTER_DD_LIST_FAILURE =
  "FETCH_GET_DEMAND_INPUT_FILTER_DD_LIST_FAILURE";

export const FETCH_WORKLIST_BY_SITE_DD_LIST_REQUEST =
  "FETCH_WORKLIST_BY_SITE_DD_LIST_REQUEST";
export const FETCH_WORKLIST_BY_SITE_DD_LIST_SUCCESS =
  "FETCH_WORKLIST_BY_SITE_DD_LIST_SUCCESS";
export const FETCH_WORKLIST_BY_SITE_DD_LIST_FAILURE =
  "FETCH_WORKLIST_BY_SITE_DD_LIST_FAILURE";

export const FETCH_WORKLIST_WITH_SITE_MAPPING_DD_LIST_REQUEST =
  "FETCH_WORKLIST_WITH_SITE_MAPPING_DD_LIST_REQUEST";
export const FETCH_WORKLIST_WITH_SITE_MAPPING_DD_LIST_SUCCESS =
  "FETCH_WORKLIST_WITH_SITE_MAPPING_DD_LIST_SUCCESS";
export const FETCH_WORKLIST_WITH_SITE_MAPPING_DD_LIST_FAILURE =
  "FETCH_WORKLIST_WITH_SITE_MAPPING_DD_LIST_FAILURE";

export const FETCH_WORKLIST_BY_WORKLISTGROUP_DD_LIST_REQUEST =
  "FETCH_WORKLIST_BY_WORKLISTGROUP_DD_LIST_REQUEST";
export const FETCH_WORKLIST_BY_WORKLISTGROUP_DD_LIST_SUCCESS =
  "FETCH_WORKLIST_BY_WORKLISTGROUP_DD_LIST_SUCCESS";
export const FETCH_WORKLIST_BY_WORKLISTGROUP_DD_LIST_FAILURE =
  "FETCH_WORKLIST_BY_WORKLISTGROUP_DD_LIST_FAILURE";

// Delete Demand Report
export const DELETE_DEMAND_REPORT_REQUEST = "DELETE_DEMAND_REPORT_REQUEST";
export const DELETE_DEMAND_REPORT_SUCCESS = "DELETE_DEMAND_REPORT_SUCCESS";
export const DELETE_DEMAND_REPORT_FAILURE = "DELETE_DEMAND_REPORT_FAILURE";

// Demand Table (6th Tab) - GetDemandTableDemandWithPagination
export const FETCH_DEMAND_TABLE_TAB_REQUEST = "FETCH_DEMAND_TABLE_TAB_REQUEST";
export const FETCH_DEMAND_TABLE_TAB_SUCCESS = "FETCH_DEMAND_TABLE_TAB_SUCCESS";
export const FETCH_DEMAND_TABLE_TAB_FAILURE = "FETCH_DEMAND_TABLE_TAB_FAILURE";

// Demand Table All Tabs Data - GetDemandTableById
export const FETCH_DEMAND_TABLE_BY_ID_REQUEST =
  "FETCH_DEMAND_TABLE_BY_ID_REQUEST";
export const FETCH_DEMAND_TABLE_BY_ID_SUCCESS =
  "FETCH_DEMAND_TABLE_BY_ID_SUCCESS";
export const FETCH_DEMAND_TABLE_BY_ID_FAILURE =
  "FETCH_DEMAND_TABLE_BY_ID_FAILURE";

// Export Onboarding Tab Actions
export const EXPORT_ONBOARDING_REQUEST = "EXPORT_ONBOARDING_REQUEST";
export const EXPORT_ONBOARDING_SUCCESS = "EXPORT_ONBOARDING_SUCCESS";
export const EXPORT_ONBOARDING_FAILURE = "EXPORT_ONBOARDING_FAILURE";

// Export Termed Tab Actions
export const EXPORT_TERMED_REQUEST = "EXPORT_TERMED_REQUEST";
export const EXPORT_TERMED_SUCCESS = "EXPORT_TERMED_SUCCESS";
export const EXPORT_TERMED_FAILURE = "EXPORT_TERMED_FAILURE";

// Export Offboarding Tab Actions
export const EXPORT_OFFBOARDING_REQUEST = "EXPORT_OFFBOARDING_REQUEST";
export const EXPORT_OFFBOARDING_SUCCESS = "EXPORT_OFFBOARDING_SUCCESS";
export const EXPORT_OFFBOARDING_FAILURE = "EXPORT_OFFBOARDING_FAILURE";

// Export Daylight Saving Ended Tab Actions
export const EXPORT_ENDED_REQUEST = "EXPORT_ENDED_REQUEST";
export const EXPORT_ENDED_SUCCESS = "EXPORT_ENDED_SUCCESS";
export const EXPORT_ENDED_FAILURE = "EXPORT_ENDED_FAILURE";

// Export Daylight Saving Upcoming Tab Actions
export const EXPORT_UPCOMING_REQUEST = "EXPORT_UPCOMING_REQUEST";
export const EXPORT_UPCOMING_SUCCESS = "EXPORT_UPCOMING_SUCCESS";
export const EXPORT_UPCOMING_FAILURE = "EXPORT_UPCOMING_FAILURE";

// Bulk Update Practice & Site Data
export const BULK_UPDATE_PRACTICE_REQUEST = "BULK_UPDATE_PRACTICE_REQUEST";
export const BULK_UPDATE_PRACTICE_SUCCESS = "BULK_UPDATE_PRACTICE_SUCCESS";
export const BULK_UPDATE_PRACTICE_FAILURE = "BULK_UPDATE_PRACTICE_FAILURE";

export const BULK_UPDATE_SITE_REQUEST = "BULK_UPDATE_SITE_REQUEST";
export const BULK_UPDATE_SITE_SUCCESS = "BULK_UPDATE_SITE_SUCCESS";
export const BULK_UPDATE_SITE_FAILURE = "BULK_UPDATE_SITE_FAILURE";

// Bulk Delete Practice & Site Data
export const BULK_DELETE_PRACTICE_REQUEST = "BULK_DELETE_PRACTICE_REQUEST";
export const BULK_DELETE_PRACTICE_SUCCESS = "BULK_DELETE_PRACTICE_SUCCESS";
export const BULK_DELETE_PRACTICE_FAILURE = "BULK_DELETE_PRACTICE_FAILURE";

export const BULK_DELETE_SITE_REQUEST = "BULK_DELETE_SITE_REQUEST";
export const BULK_DELETE_SITE_SUCCESS = "BULK_DELETE_SITE_SUCCESS";
export const BULK_DELETE_SITE_FAILURE = "BULK_DELETE_SITE_FAILURE";

// Bulk Update Worklist Data
export const BULK_UPDATE_WORKLIST_REQUEST = "BULK_UPDATE_WORKLIST_REQUEST";
export const BULK_UPDATE_WORKLIST_SUCCESS = "BULK_UPDATE_WORKLIST_SUCCESS";
export const BULK_UPDATE_WORKLIST_FAILURE = "BULK_UPDATE_WORKLIST_FAILURE";

// Bulk Delete Worklist Data
export const BULK_DELETE_WORKLIST_REQUEST = "BULK_DELETE_WORKLIST_REQUEST";
export const BULK_DELETE_WORKLIST_SUCCESS = "BULK_DELETE_WORKLIST_SUCCESS";
export const BULK_DELETE_WORKLIST_FAILURE = "BULK_DELETE_WORKLIST_FAILURE";

// Export Practice Data
export const EXPORT_PRACTICE_REQUEST = "EXPORT_PRACTICE_REQUEST";
export const EXPORT_PRACTICE_SUCCESS = "EXPORT_PRACTICE_SUCCESS";
export const EXPORT_PRACTICE_FAILURE = "EXPORT_PRACTICE_FAILURE";

// Export Site Data
export const EXPORT_SITE_REQUEST = "EXPORT_SITE_REQUEST";
export const EXPORT_SITE_SUCCESS = "EXPORT_SITE_SUCCESS";
export const EXPORT_SITE_FAILURE = "EXPORT_SITE_FAILURE";

export const EXPORT_WORKLIST_REQUEST = "EXPORT_WORKLIST_REQUEST";
export const EXPORT_WORKLIST_SUCCESS = "EXPORT_WORKLIST_SUCCESS";
export const EXPORT_WORKLIST_FAILURE = "EXPORT_WORKLIST_FAILURE";

// Fetch Demand Changes Practice Data
export const FETCH_DEMAND_CHANGES_PRACTICE_REQUEST =
  "FETCH_DEMAND_CHANGES_PRACTICE_REQUEST";
export const FETCH_DEMAND_CHANGES_PRACTICE_SUCCESS =
  "FETCH_DEMAND_CHANGES_PRACTICE_SUCCESS";
export const FETCH_DEMAND_CHANGES_PRACTICE_FAILURE =
  "FETCH_DEMAND_CHANGES_PRACTICE_FAILURE";

// Fetch Demand Changes Site Data
export const FETCH_DEMAND_CHANGES_SITE_REQUEST =
  "FETCH_DEMAND_CHANGES_SITE_REQUEST";
export const FETCH_DEMAND_CHANGES_SITE_SUCCESS =
  "FETCH_DEMAND_CHANGES_SITE_SUCCESS";
export const FETCH_DEMAND_CHANGES_SITE_FAILURE =
  "FETCH_DEMAND_CHANGES_SITE_FAILURE";

// Fetch/Apply Demand Changes Worklist Data
export const FETCH_DEMAND_CHANGES_WORKLIST_REQUEST =
  "FETCH_DEMAND_CHANGES_WORKLIST_REQUEST";
export const FETCH_DEMAND_CHANGES_WORKLIST_SUCCESS =
  "FETCH_DEMAND_CHANGES_WORKLIST_SUCCESS";
export const FETCH_DEMAND_CHANGES_WORKLIST_FAILURE =
  "FETCH_DEMAND_CHANGES_WORKLIST_FAILURE";

// Refresh Demand Table Actions
export const REFRESH_DEMAND_TABLE_REQUEST = "REFRESH_DEMAND_TABLE_REQUEST";
export const REFRESH_DEMAND_TABLE_SUCCESS = "REFRESH_DEMAND_TABLE_SUCCESS";
export const REFRESH_DEMAND_TABLE_FAILURE = "REFRESH_DEMAND_TABLE_FAILURE";

// Save as Draft Actions
export const SAVE_AS_DRAFT_REQUEST = "SAVE_AS_DRAFT_REQUEST";
export const SAVE_AS_DRAFT_SUCCESS = "SAVE_AS_DRAFT_SUCCESS";
export const SAVE_AS_DRAFT_FAILURE = "SAVE_AS_DRAFT_FAILURE";

// Publish Report Actions
export const PUBLISH_DEMAND_TABLE_REQUEST = "PUBLISH_DEMAND_TABLE_REQUEST";
export const PUBLISH_DEMAND_TABLE_SUCCESS = "PUBLISH_DEMAND_TABLE_SUCCESS";
export const PUBLISH_DEMAND_TABLE_FAILURE = "PUBLISH_DEMAND_TABLE_FAILURE";

// View Demand Table Actions
export const VIEW_DEMAND_TABLE_REQUEST = "VIEW_DEMAND_TABLE_REQUEST";
export const VIEW_DEMAND_TABLE_SUCCESS = "VIEW_DEMAND_TABLE_SUCCESS";
export const VIEW_DEMAND_TABLE_FAILURE = "VIEW_DEMAND_TABLE_FAILURE";

// Fetch Holiday Coverage Worklist Data
export const FETCH_HOLIDAY_COVERAGE_WORKLIST_REQUEST =
  "FETCH_HOLIDAY_COVERAGE_WORKLIST_REQUEST";
export const FETCH_HOLIDAY_COVERAGE_WORKLIST_SUCCESS =
  "FETCH_HOLIDAY_COVERAGE_WORKLIST_SUCCESS";
export const FETCH_HOLIDAY_COVERAGE_WORKLIST_FAILURE =
  "FETCH_HOLIDAY_COVERAGE_WORKLIST_FAILURE";

// Common update reducer
export const UPDATE_DEMAND_TABLE_REDUCER = "UPDATE_DEMAND_TABLE_REDUCER";

// Reset reducer to initial state
export const RESET_DEMAND_TABLE_STATE = "RESET_DEMAND_TABLE_STATE";
